<div
  class="modal fade"
  id="staticChangePasswordBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticChangePassowrdBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="dialogue-title">{{ this.dialogService.title }}</h4>
      </div>
      <div class="modal-body">
        {{ this.dialogService.message }}
      </div>
      <div class="modal-footer">
        <button class="btn btn--cancel" (click)="goBack()">Odustani</button>
        <button
          type="button"
          class="btn btn--confirm"
          id="btn-ok"
          data-dismiss="modal"
          (click)="redirectToMaxBet()"
        >
          U redu
        </button>
      </div>
    </div>
  </div>
</div>
